import { cn } from './cn';
import { STATUS, R, type StatusVariant } from './tokens';

interface BadgeProps {
  variant?: StatusVariant;
  color?: string;
  solid?: boolean;
  className?: string;
  children?: React.ReactNode;
}

export function Badge({
  variant = 'neutral',
  color,
  solid = false,
  className,
  children,
}: BadgeProps) {
  const base = cn('inline-flex items-center px-2 py-0.5 text-xs font-medium', R.full);

  if (color) {
    return (
      <span
        className={cn(base, 'text-white', className)}
        style={{ backgroundColor: color }}
      >
        {children}
      </span>
    );
  }

  const token = STATUS[variant];
  const colorClasses = solid
    ? cn(token.solid, 'text-white')
    : cn(token.bg, token.text);

  return (
    <span className={cn(base, colorClasses, className)}>
      {children}
    </span>
  );
}
